<template>
  <div>

    <main class="transparent">
      <v-parallax dark height="900" src="../assets/images/theme.jpg">
        <v-card flat class="ma-10 card-light" height="1000" :rounded="rounded">

          <v-toolbar color="primary" dark height="350" extended flat>

          </v-toolbar>

          <v-card :rounded="rounded" class="mx-auto transparent elevation-0 " outlined max-width="600" height="300"
                  style="margin-top: -164px;">


            <v-row align="center" justify="center">
              <v-col class="text-center" cols="12" md="12" sm="12">

                <h1 class="text-h4 font-weight-thin mb-4 d-none d-lg-block">
                  <img  src="../assets/images/logo1.png">
                </h1> <h1 class="text-h4 font-weight-thin mb-4 d-flex d-sm-none  text-sm-body-2">
                  <img style="max-width:200px" src="../assets/images/logo1.png">
                </h1>
                <h4 class="text-h3 white--text  d-none d-lg-block mt-n10 font-weight-black">
                  Admin Personal Template
                </h4>
              </v-col>
            </v-row>
            <v-row align="center" justify="center">
              <v-col cols="12">
                <div class="ma-auto" style="max-width: 300px">
                  <v-otp-input v-model="otp" :length="length"></v-otp-input>
                </div>
                <div class="text-center white--text">
                  Expected value: <span class="font-weight-bold">{{ expectedOtp }}</span>
                </div>
              </v-col>

              <v-col cols="12" class="text-center">
                <v-btn class="mx-auto text-center" :disabled="!isActive">Ready</v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-card>
      </v-parallax>
    </main>

  </div>
</template>

<script>
  import BaseCard from '../components/Base/BaseCard'
  export default {
    components: {
      BaseCard
    },
    data: () => ({
      loading: false,
      snackbar: false,
      snackbarColor: 'default',
      otp: '',
      length: 4,
      expectedOtp: '1234',
    }),
    methods: {
      onFinish(rsp) {
        this.loading = true
        setTimeout(() => {
          this.loading = false
          this.snackbarColor = (rsp === this.expectedOtp) ? 'success' : 'warning'
          this.text = `Processed OTP with "${rsp}" (${this.snackbarColor})`
          this.snackbar = true
        }, 3500)
      },
      godashboard1() {
        return this.$router.push("/dashboard/dashboard1");
      },
    },
    computed: {
      isActive() {
        if (this.otp.length === this.length) {
          return this.$router.push("/dashboard/dashboard1");
        }


      },
    },
  }
</script>

<style scoped>
  .home-main {
    background-image: url('../assets/images/theme.jpg');
    background-size: 100%
  }

  .card-light {
    border-radius: 1em;
    border: 1px solid rgba(255, 255, 255, 0.5);
    text-shadow: 0 0 1em rgba(0, 0, 0, 0.5);
    background: rgba(255, 255, 255, 0.2);
    -webkit-backdrop-filter: blur(20px);
    backdrop-filter: blur(20px);
    transform: perspective(500px);
    transform-style: preserve-3d;
  }

  .card-dark {
    border-radius: 1em;
    border: 1px solid rgba(0, 0, 0, 0.5);
    text-shadow: 0 0 1em rgba(245, 245, 245, 0.5);
    background: rgba(0, 0, 0, 0.2);
    -webkit-backdrop-filter: blur(20px);
    backdrop-filter: blur(20px);
    transform: perspective(500px);
    transform-style: preserve-3d;
  }
</style>

<style scoped>
  .position-relative {
    position: relative;
  }
</style>